// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__20QH3","content":"styles_content__11mvX","selectAll":"styles_selectAll__3QKEk"};